export default "__VITE_PUBLIC_ASSET__f4c4c1bd__"